import React from "react";
import { motion } from "framer-motion";
interface AnimatedCardProps {
  children: React.ReactNode;
  delay?: number;
}
export const AnimatedCard = ({
  children,
  delay = 0
}: AnimatedCardProps) => {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: "-50px"
  }} transition={{
    duration: 0.5,
    delay,
    ease: "easeOut"
  }}>
      {children}
    </motion.div>;
};